import React, { useState } from "react"
import { Button, Stack, Text } from "@carrotfertility/carotene"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { CaseRateRenewalModalTopSection } from "../CaseRateRenewalModalTopSection"
import { CaseRateRenewalModalButtonGroup } from "../CaseRateRenewalModalButtonGroup"
import { useStartCaseRateRenewalRouting } from "../useQueryCaseRateRenewals"
import { FormattedMessage, useIntl } from "react-intl"

export function UpdateCarrotPlanDetailsStep(): JSX.Element {
  const intl = useIntl()
  const { back } = useStateMachine(null)
  const [updateMyAnswersIsLoading, setUpdateMyAnswersIsLoading] = useState(false)
  const { startCaseRateRenewalRouting } = useStartCaseRateRenewalRouting()

  async function updateMyAnswers(): Promise<void> {
    setUpdateMyAnswersIsLoading(true)
    await startCaseRateRenewalRouting()
  }

  return (
    <>
      <CaseRateRenewalModalTopSection
        header={intl.formatMessage({
          defaultMessage: "We have a few questions..."
        })}
        showImage
        showBack
        back={back}
        imageAltText={intl.formatMessage({
          defaultMessage: "underwater desktop"
        })}
        imageSrc="/images/illo-underwater-desktop"
      />
      <Stack spacing={["large", "huge"]}>
        <Text>
          <FormattedMessage
            defaultMessage="When you first started using Carrot, you may have answered some questions about your journey. To help us best
          support you now, please answer or update your answers to the following."
          />
        </Text>
        <CaseRateRenewalModalButtonGroup
          buttonOne={
            <Button disabled={updateMyAnswersIsLoading} variant="secondary" onClick={back}>
              <FormattedMessage defaultMessage="Go back" />
            </Button>
          }
          buttonTwo={
            <Button disabled={updateMyAnswersIsLoading} onClick={updateMyAnswers} variant="primary">
              <FormattedMessage defaultMessage="Update my answers" />
            </Button>
          }
        />
      </Stack>
    </>
  )
}
